// extracted by mini-css-extract-plugin
export default {"accordion":"CompanyAccordion_accordion__ljmzB","accordionHeader":"CompanyAccordion_accordionHeader__8tD9r","accordionItem":"CompanyAccordion_accordionItem__ihcSJ"};